export const getInitialSearchOptions = (props: { categoryCount: number, productCount:number }) => ({
    format: "json",
    return_filters: true,
    filters: [] as string[],
    sorting: [""] as string[],
    engine_options: {
        product: {
            current_count: props.productCount,
            start: 0
        },
        category: {
            current_count: props.categoryCount,
            start: 0
        },
        // site_page: {  // Not needed now. Can be uncommented when ever these inputs needed
        //     current_count: 2,
        //     start: 0
        // },
        // blog_post: {
        //     current_count: 1,
        //     start: 0
        // },
        // brand: {
        //     current_count: 2,
        //     start: 0
        // },
        redirects: {
            current_count: 2,
            start: 0
        }
    }
});

export const INIT_PRICE_RANGE = {
    minPrice:-1,
    maxPrice:-1
}

export const SORT_OPTIONS = [
    {
        key: "RELEVENCE",
        value: "relevance",
        translationKey: 'relevance',
    },
    {
        key: 'PRICE_SORT_NAME',
        value: 'title asc',
        translationKey: 'name',
    },
    {
        key: 'PRICE_SORT_LOW_TO_HIGH',
        value: 'price asc',
        translationKey: 'priceLowToHigh',
    },
    {
        key: 'PRICE_SORT_HIGH_TO_LOW',
        value: 'price desc',
        translationKey: 'priceHighToLow',
    },
]

export const MAX_INITIAL_FILTER_SHOW_COUNT = 5;

export const HELLO_RETAIL_TRACKING_ID = "hello_retail_id";